const ApiConfig = {
  baseUrl: "https://apis.panoramix.art/api/v1"
}

export default ApiConfig;
